module.exports = __webpack_public_path__ + "6c266f52b1a291ee757afff2efd4cd90.otf";